import React, { useEffect, useState } from 'react';
import Keycloak from 'keycloak-js';
import { useDispatch, useSelector } from 'react-redux';
import { handleSetSesion } from '../../redux/slices/authSlice';
import { getPaths } from '../../helpers/getPathsRecursively';
import { Box, CircularProgress } from '@mui/material';
import { setUserDetails } from '../../helpers/analytics';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const [keycloak, setKeycloak] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // nuevo estado para loading

  const { menuList } = useSelector((state) => state.menuReducer);

  const accessPaths = [...getPaths(menuList), '/dev/level-desk'];

  const handleSesion = (sesionData) => {
    dispatch(handleSetSesion(sesionData));
  };

  useEffect(() => {
    const initKeycloak = async () => {
      const keycloakInstance = new Keycloak({
        url: process.env.REACT_APP_KC_HOST,
        realm: process.env.REACT_APP_KC_REALM,
        clientId: process.env.REACT_APP_KC_CLIENT_ID,
      });

      try {
        const authenticated = await keycloakInstance.init({
          onLoad: 'login-required',
          checkLoginIframe: false,
        });

        if (!authenticated) {
          keycloakInstance.login();
        } else {
          setKeycloak(keycloakInstance);
          handleSesion(keycloakInstance);
          // idTokenParsed suele contener email; tokenParsed (access_token) a veces no
          const userInfo = keycloakInstance.idTokenParsed || keycloakInstance.tokenParsed;
          setUserDetails(keycloakInstance.subject, userInfo);
        }
      } catch (error) {
        console.error('Error inicializando Keycloak:', error);
        //keycloakInstance.logout();
        //keycloakInstance.login();
      } finally {
        setIsLoading(false);
      }
    };

    initKeycloak();
  }, []);

  // Mostrar algo mientras carga
  if (isLoading)
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        width={1}
        height={'100vh'}
      >
        <CircularProgress />
      </Box>
    );

  /*
  // si el path actual no esta en el menu paths, no se devuelve la pagina
  if (accessPaths.length > 0 && !accessPaths.includes(window.location.pathname)) {
    return <div>No tienes permisos</div>
  }
    */

  // Si está autenticado, renderiza children
  if (keycloak && keycloak.authenticated) {
    return children;
  }

  // Si no está autenticado y no se redirigió aún, bloquea render
  return null;
};

export default PrivateRoute;
